import { Messages } from "./Messages";
import { SendBox } from "../SendBox/SendBox";
import { IconButton } from "@mui/material";
import { MoreHoriz } from "@mui/icons-material";
import React, { useState } from "react";
import { aderantColors } from "../../Theme/aderantColors";
import "./ChatMessageComponent.css";
import "./Loading.css";
import { PersonIcon } from "../../Icons/PersonIcon/PersonIcon";
/**
 * Component displaying a message within a chat message thread.
 */
export function ChatMessageComponent(props) {
    const { message, showMessageDate, showMessageTime, disableActions, styles, onActionClick, isEditingMessage, isUpdatingMessage, onUpdateMessage, onCancelEdit, isActionMenuButtonVisible, sendBoxPopupProps, handleMessageHover } = props;
    const [editedText, setEditedText] = useState(message.content ?? "");
    const defaultStyles = {
        container: {},
        header: { fontSize: "0.75rem" },
        personIcon: {},
        content: { width: "calc(100% - 34px)" },
        sender: {
            fontWeight: "600",
            textOverflow: "ellipsis",
            flexWrap: "nowrap",
            color: aderantColors.DarthVaderAlt,
            flexShrink: 1
        },
        timestamp: {
            color: aderantColors.DarthVaderAlt
        },
        details: {
            fontWeight: "600",
            color: aderantColors.DarthVaderAlt
        },
        text: {
            wordWrap: "break-word",
            color: aderantColors.DarthVaderAlt
        },
        actionButton: {
            display: isActionMenuButtonVisible ? "block" : "none",
            color: aderantColors.R2D2
        }
    };
    const getCombinedStyles = (defaultStyles, styles) => {
        const combinedStyles = { ...defaultStyles };
        if (styles) {
            if (styles.container) {
                combinedStyles.container = { ...defaultStyles.container, ...styles.container };
            }
            if (styles.personIcon) {
                combinedStyles.personIcon = { ...defaultStyles.personIcon, ...styles.personIcon };
            }
            if (styles.content) {
                combinedStyles.content = { ...defaultStyles.content, ...styles.content };
            }
            if (styles.sender) {
                combinedStyles.sender = { ...defaultStyles.sender, ...styles.sender };
            }
            if (styles.timestamp) {
                combinedStyles.timestamp = { ...defaultStyles.timestamp, ...styles.timestamp };
            }
            if (styles.text) {
                combinedStyles.text = { ...defaultStyles.text, ...styles.text };
            }
            if (styles.actionButton) {
                combinedStyles.actionButton = { ...defaultStyles.actionButton, ...styles.actionButton };
            }
        }
        return combinedStyles;
    };
    const combinedStyles = getCombinedStyles(defaultStyles, styles);
    const defaultRenderer = (messageProps) => {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { id: message.messageId, "aria-label": "Chat Message", className: "aderant-ChatMessage", style: combinedStyles.container, onMouseEnter: handleMessageHover, onMouseLeave: handleMessageHover },
                isUpdatingMessage ? (React.createElement("div", { "aria-label": "Loading...", className: "loader-wrapper" },
                    React.createElement("div", { className: "loading typing_loader" }))) : message.mine ? (
                //Current User's icon
                React.createElement(PersonIcon, { ariaLabel: "Chat Message My Icon", text: message.senderDisplayName, size: "medium", backgroundColor: aderantColors.Ahsoka, textColor: aderantColors.Stormtrooper, style: combinedStyles.personIcon })) : (
                //Other User's icon
                React.createElement(PersonIcon, { ariaLabel: "Chat Message Other User Icon", text: message.senderDisplayName, size: "medium", backgroundColor: aderantColors.MillenniumFalcon, textColor: aderantColors.DarthVaderAlt, style: combinedStyles.personIcon })),
                React.createElement("div", { className: "aderant-ChatMessage-body", style: combinedStyles.content },
                    React.createElement("div", { className: "aderant-ChatMessage-header", style: combinedStyles.header },
                        React.createElement("div", { className: "aderant-ChatMessage-header-left" },
                            React.createElement("div", { "aria-label": "Chat Message Author", className: "aderant-ChatMessage-author", style: combinedStyles.sender }, message.senderDisplayName)),
                        React.createElement("div", { className: "aderant-ChatMessage-header-right" },
                            showMessageDate && (React.createElement("div", { "aria-label": "Chat Message Date Stamp", className: "aderant-ChatMessage-datestamp", style: combinedStyles.timestamp }, showMessageTime
                                ? Intl.DateTimeFormat("default", { year: "numeric", month: "2-digit", day: "2-digit", hour: "numeric", minute: "2-digit" }).format(message.createdOn)
                                : Intl.DateTimeFormat("default", { year: "numeric", month: "2-digit", day: "2-digit" }).format(message.createdOn))),
                            message.editedOn && (React.createElement("div", { "aria-label": "Details", style: combinedStyles.details }, Messages.EDITED.getMessage())),
                            !disableActions && (
                            //Render action button for other user's messages too, even though it will never be visible,
                            //so it leaves the space in the dom to line up the messages
                            React.createElement("div", { className: "aderant-ChatMessage-actions-button-container" },
                                React.createElement(IconButton, { "aria-label": "Chat Message Action Button", className: "aderant-ChatMessage-actions-button", size: "small", style: combinedStyles.actionButton, onClick: onActionClick },
                                    React.createElement(MoreHoriz, null)))))),
                    isEditingMessage ? (React.createElement(SendBox, { messageId: message.messageId, strings: { placeholderText: "Enter text" }, onUpdateMessage: onUpdateMessage, mode: "edit", onCancelEdit: onCancelEdit, originalTextValue: editedText, setOriginalTextValue: setEditedText, autoFocus: "sendBoxTextField", popupProps: sendBoxPopupProps })) : (React.createElement("div", { "aria-label": "Chat Message Content", className: "aderant-ChatMessage-text", style: combinedStyles.text }, message.content))))));
    };
    const renderer = props.onRenderMessage ?? defaultRenderer;
    return React.createElement(React.Fragment, null, renderer(props));
}
